import { useEffect } from "react";
import { TbError404 } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../languages";
const UnderDevelopment = () => {
  const navigateTo = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      style={{ minHeight: "90vh" }}
      className="d-flex align-items-center justify-content-center"
    >
      <div>
        <h1 className="text-center" style={{ fontSize: 50 }}>
          {t("pageNotFound")}
        </h1>
        <h4 className="f-5 text-center text-black mb-2">{t("activityMaps")}</h4>
        <p className="f-4 text-center">
          {t("pageRemovedOrUnderDev")} {t("navigateHome")}
        </p>
      </div>
    </div>
  );
};

export default UnderDevelopment;
